import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TableColumn, BubbleDirective } from '@ui/aos-lib';
import { BaseStationItemListResponseDto, BaseStationProvisioningStatus } from '../base-stations-listing-page.types';
import { provisioningStatusBubbleMap, provisioningStatusLabelMap } from './provisioning-status.constants';

@Component({
  selector: 'aos-provisioning-status-column',
  template: `
    @if (item) {
      @let status = getProvisioningStatus(item.provisioningStatus);
      @if (status) {
        <span
          popoverContent
          [uiBubble]="provisioningStatusBubbleMap[status]"
        >
          {{ provisioningStatusLabelMap[status] | translate }}
        </span>
      } @else {
        <span>{{ item.provisioningStatus }}</span>
      }
    }
  `,
  imports: [TranslateModule, BubbleDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProvisioningStatusColumnComponent {
  @Input() item!: BaseStationItemListResponseDto;
  @Input() column!: TableColumn;

  protected readonly provisioningStatusLabelMap = provisioningStatusLabelMap;
  protected readonly provisioningStatusBubbleMap = provisioningStatusBubbleMap;

  protected getProvisioningStatus(
    status: BaseStationItemListResponseDto['provisioningStatus']
  ): BaseStationProvisioningStatus | null {
    return Object.values(BaseStationProvisioningStatus).includes(status as BaseStationProvisioningStatus)
      ? (status as BaseStationProvisioningStatus)
      : null;
  }
}
